module.exports = __webpack_public_path__ + "static/img/ysbj-DI3_66Vp.e1065b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/ysbj-DI3_66Vp.png
// module id = GnEM
// module chunks = 16